import React from "react";
import { useMessageSource } from "react-message-source";
import { AlertProps, Alert as MuiAlert } from "@mui/material";
import "./styles.scss";
import { useMediaQuery } from "@mui/material";
import { breakpointValues } from "../../../../../../theme/theme";
import { FormikErrors } from "formik";

interface InvalidFormErrorProps {
  isDisplayed: boolean;
}

export const Alert = (props: AlertProps): React.JSX.Element => {
  return <MuiAlert variant="filled" {...props} />;
};

const largeScreens = `only screen and (min-width: ${breakpointValues.md}px)`;

export const isSubmitErrorMessageShown = <T,>(
  submitCount: number,
  errors: FormikErrors<T>,
): boolean => {
  return submitCount !== 0 && Object.keys(errors).length !== 0;
};

const InvalidFormError: React.FC<InvalidFormErrorProps> = ({
  isDisplayed,
}: InvalidFormErrorProps) => {
  const { getMessage } = useMessageSource();
  const isCurrentScreenLarge = useMediaQuery(largeScreens);

  const errorLargeScreens = () => {
    return (
      <Alert severity="error" className="scd-alert-error">
        {getMessage("Onboarding.continue.error")}
      </Alert>
    );
  };

  const errorSmallScreens = () => {
    return (
      <Alert severity="error" className="scd-alert-error">
        {getMessage("Onboarding.continue.error-short")}
      </Alert>
    );
  };

  return (
    <>
      {isDisplayed &&
        (isCurrentScreenLarge ? errorLargeScreens() : errorSmallScreens())}
    </>
  );
};

export default InvalidFormError;
